<template>
  <div class="print-previous-replies">
    <printing-page>
      <papers-header></papers-header>

      <paper>
        <row>
          <column full-width>
            <block>
              <papers-table
                :headers="[]"
                :items="printData"
              ></papers-table>
            </block>
          </column>
        </row>
      </paper>

      <papers-footer></papers-footer>
      <action></action>
    </printing-page>
  </div>
</template>

<script>
import PrintingPage from '@/components/printing/page.vue';
import Paper from '@/components/printing/paper.vue';
import Row from '@/components/printing/row.vue';
import Column from '@/components/printing/column.vue';
import Block from '@/components/printing/block.vue';
import PapersHeader from '@/components/printing/header.vue';
import PapersFooter from '@/components/printing/footer.vue';
import PapersTable from '@/components/printing/table.vue';
import Action from '@/components/printing/action.vue';
import mock from '@/local/mock.json';

export default {
  name: 'PrintBill',
  components: {
    PrintingPage,
    Paper,
    PapersHeader,
    PapersFooter,
    PapersTable,
    Action,
    Block,
    Row,
    Column,
  },
  // props: {
  //   objectKey: {
  //     type: Array,
  //     required: true,
  //   },
  // },
  data() {
    return {
      mock,
      printData: null,
    };
  },
  computed: {
    objectKey() {
      return this.$route.params.objectKey;
    },
  },
  watch: {},
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.printData = this.mock.billDetails;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
